export enum State {
  DE = "Delaware",
  HI = "Hawaii",
  PR = "Puerto Rico",
  TX = "Texas",
  MA = "Massachusetts",
  MD = "Maryland",
  IA = "Iowa",
  ME = "Maine",
  ID = "Idaho",
  MI = "Michigan",
  UT = "Utah",
  AA = "Armed forces - America",
  MN = "Minnesota",
  MO = "Missouri",
  IL = "Illinois",
  MP = "Northern Marianas Islands",
  AE = "Armed forces - Europe",
  IN = "Indiana",
  MS = "Mississippi",
  MT = "Montana",
  AK = "Alaska",
  AL = "Alabama",
  VA = "Virginia",
  AP = "Armed forces - Pacific",
  AR = "Arkansas",
  VI = "Virgin Islands",
  NC = "North Carolina",
  ND = "North Dakota",
  NE = "Nebraska",
  RI = "Rhode Island",
  AZ = "Arizona",
  NH = "New Hampshire",
  NJ = "New Jersey",
  VT = "Vermont",
  NM = "New Mexico",
  FL = "Florida",
  NV = "Nevada",
  WA = "Washington",
  NY = "New York",
  SC = "South Carolina",
  SD = "South Dakota",
  WI = "Wisconsin",
  OH = "Ohio",
  GA = "Georgia",
  OK = "Oklahoma",
  CA = "California",
  WV = "West Virginia",
  WY = "Wyoming",
  OR = "Oregon",
  KS = "Kansas",
  CO = "Colorado",
  KY = "Kentucky",
  GU = "Guam",
  CT = "Connecticut",
  PA = "Pennsylvania",
  LA = "Louisiana",
  TN = "Tennessee",
  DC = "District of Columbia"
};
